import Chart from "chart.js/auto";

$(function () {
    if ($(".nursery-analytics").length === 0) {
        return;
    }

    // --- 時系列グラフ (折れ線 + 棒) ---
    const timeSeriesCtx = document.getElementById("timeSeriesChart").getContext("2d");
    timeSeriesCtx.canvas.height = "100%";
    const timeSeriesChartData = JSON.parse(
        document.getElementById("nursery-analytics-charts").dataset.timeSeriesChartData
    );

    const { labels, viewsData, uniqueViewsData, reservationsData, keepCountData } = timeSeriesChartData.reduce(
        (acc, item) => {
            acc.labels.push(item.label);
            acc.viewsData.push(item.page_view);
            acc.uniqueViewsData.push(item.active_user);
            acc.reservationsData.push(item.visit_inquiry);
            acc.keepCountData.push(item.keep_count);
            return acc;
        },
        { labels: [], viewsData: [], uniqueViewsData: [], reservationsData: [], keepCountData: [] }
    );

    new Chart(timeSeriesCtx, {
        type: "bar", // 基本のタイプをbarに設定
        data: {
            labels: labels,
            datasets: [
                {
                    yAxisID: "y_left",
                    type: "line", // このデータセットは折れ線グラフ
                    label: "このページが見られた回数",
                    data: viewsData,
                    borderColor: "#3b82f6",
                    borderWidth: 2,
                    pointRadius: 2 // データポイントを表示
                },
                {
                    yAxisID: "y_left",
                    type: "line", // このデータセットは折れ線グラフ
                    label: "このページを見た人数",
                    data: uniqueViewsData,
                    borderColor: "#ef4444",
                    borderWidth: 2,
                    pointRadius: 2 // データポイントを表示
                },
                {
                    yAxisID: "y_right",
                    type: "bar", // このデータセットは棒グラフ
                    label: "キープ数",
                    data: keepCountData,
                    backgroundColor: "#FCC740"
                },
                {
                    yAxisID: "y_right",
                    type: "bar", // このデータセットは棒グラフ
                    label: "見学予約数",
                    data: reservationsData,
                    backgroundColor: "#00B2BC"
                }
            ]
        },
        options: {
            maintainAspectRatio: false, // アスペクト比維持
            responsive: true, // レスポンシブ対応
            scales: {
                x: {
                    title: {
                        display: true,
                        text: "週" // 横軸のメモリのタイトル
                    },
                    grid: {
                        display: false // 横軸のグリッド線を非表示
                    },
                    ticks: {
                        maxRotation: 90, // 文字の傾きの最大確度（90まで傾くと縦になる）
                        minRotation: 0, // 文字の傾き最小確度（0は横になる）
                        maxTicksLimit: 15 // ラベルの最大表示数
                    }
                },
                y_left: {
                    beginAtZero: true,
                    ticks: {
                        stepSize: 1, // 縦軸の目盛り間隔
                        maxTicksLimit: 5
                    },
                    position: "left" // 左側に表示
                },
                y_right: {
                    beginAtZero: true,
                    ticks: {
                        stepSize: 1, // 縦軸の目盛り間隔
                        maxTicksLimit: 5
                    },
                    position: "right", // 右側に表示
                    suggestedMax: 10 // 右側の最大値を10に設定
                }
            },
            interaction: {
                // マウスホバーしたときの設定
                mode: "index",
                intersect: false
            },
            plugins: {
                legend: {
                    display: false // カスタム凡例を使用するため非表示
                }
            }
        }
    });

    const referralsChartData = JSON.parse(
        document.getElementById("nursery-analytics-referrals").dataset.referralsChartData
    );

    // 水平棒グラフのオプション
    const barChartOptions = {
        indexAxis: "y",
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
            legend: { display: false },
            tooltip: { enabled: false }
        },
        scales: {
            x: {
                display: false,
                beginAtZero: true,
                max: 120
            },
            y: {
                display: false
            }
        }
    };

    const barDataLabelPlugin = {
        afterDatasetsDraw(chart) {
            chart.data.datasets.forEach((dataset, datesetIndex) => {
                const meta = chart.getDatasetMeta(datesetIndex);
                meta.data.forEach(function (bar, metaIndex) {
                    const data = dataset.data[metaIndex];
                    // パーセンテージ表示をバーの右端に描画
                    chart.ctx.fillText(`${data}%`, bar.x + 8, bar.y + 4);
                });
            });
        }
    };

    // 各流入元の「このページが見られた回数」のグラフを作成
    referralsChartData.forEach((item, index) => {
        const viewsCtx = document.getElementById(`viewsChart${index + 1}`).getContext("2d");

        new Chart(viewsCtx, {
            type: "bar",
            data: {
                labels: [""],
                datasets: [
                    {
                        data: [item.page_view],
                        backgroundColor: "#3b82f6",
                        barThickness: 15
                    }
                ]
            },
            options: barChartOptions,
            plugins: [barDataLabelPlugin]
        });
    });
});
